import { formatISODatetimeForAnalytics } from 'sprout-api-client/src/dates';
import { PROFILE_METRICS } from './metrics';
import { makeSlices, reportErrorReason } from '../helpers/general-helpers';
import { generateLessThanOneYearDateSlices } from '../helpers/DateRangeGenerator';
var PROFILE_METRICS_FIELDS = [
    { apiKey: 'customer_profile_id', column: { id: 'customer_profile_id', dataType: 'int', alias: 'Customer Profile ID' } },
    { apiKey: 'reporting_period.by(day)', column: { id: 'reporting_day', dataType: 'date', alias: 'Reporting Day' } },
];
var ProfileMetrics = /** @class */ (function () {
    function ProfileMetrics() {
        this.id = 'profile_metrics';
        this.alias = 'Profile Metrics';
    }
    ProfileMetrics.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: PROFILE_METRICS_FIELDS.map(function (profileMetricProperty) { return profileMetricProperty.column; }).concat(PROFILE_METRICS.map(function (profileMetricProperty) { return profileMetricProperty.column; })),
        };
    };
    ProfileMetrics.prototype.getData = function (connector, table, done) {
        asyncGetProfileMetrics({
            connector: connector,
            table: table,
            done: done,
            rowsFormatter: function (response) {
                return response.data.map(function (profileMetricsData) {
                    var result = new Map();
                    // Set the non-metrics values we require for the table ... cp_id, reporting day ...
                    PROFILE_METRICS_FIELDS.forEach(function (field) {
                        var _a;
                        var value = (_a = profileMetricsData.dimensions) === null || _a === void 0 ? void 0 : _a[field.apiKey];
                        if (value !== undefined) {
                            result.set(field.column.id, value);
                        }
                    });
                    // Set all the metrics we require for the table ...
                    PROFILE_METRICS.forEach(function (metric) {
                        var _a;
                        var value = (_a = profileMetricsData.metrics) === null || _a === void 0 ? void 0 : _a[metric.apiKey];
                        if (value !== undefined) {
                            // Todo: fix types of metric values ...
                            result.set(metric.column.id, value);
                        }
                    });
                    return Object.fromEntries(result);
                });
            },
        });
    };
    return ProfileMetrics;
}());
export var PROFILE_SLICE_SIZE = 100;
export var asyncGetProfileMetrics = function (_a) {
    var connector = _a.connector, table = _a.table, done = _a.done, rowsFormatter = _a.rowsFormatter;
    var startPage = 1;
    var processingContext = { totalCountProcessed: 0 };
    connector
        .getCustomerProfileIdsSupportedByAnalyticsForProfilesEndpoint()
        .then(function (customerProfileIds) {
        var promises = makeSlices(customerProfileIds, PROFILE_SLICE_SIZE).flatMap(function (idSlice) {
            var dateSlices = generateLessThanOneYearDateSlices({ start: connector.getStartDate(), end: connector.getEndDate() }, true);
            return dateSlices.map(function (dateSlice) {
                var bodyParams = {
                    page: startPage,
                    startDate: dateSlice[0],
                    endDate: dateSlice[1],
                };
                return getProfileMetrics({
                    customerProfileIds: idSlice,
                    connector: connector,
                    table: table,
                    done: done,
                    bodyParams: bodyParams,
                    rowsFormatter: rowsFormatter,
                    processingContext: processingContext,
                });
            });
        });
        return Promise.all(promises);
    })
        .then(function () {
        done();
    })
        .catch(function (reason) {
        reportErrorReason(reason, connector.getTableau());
    })
        .finally(function () {
        connector.getTableau().reportProgress('');
    });
};
var getProfileMetrics = function (_a) {
    var customerProfileIds = _a.customerProfileIds, connector = _a.connector, table = _a.table, done = _a.done, bodyParams = _a.bodyParams, rowsFormatter = _a.rowsFormatter, processingContext = _a.processingContext;
    var page = bodyParams.page, startDate = bodyParams.startDate, endDate = bodyParams.endDate;
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            var body = {
                filters: [
                    "customer_profile_id.eq(".concat(customerProfileIds.join(','), ")"),
                    "reporting_period.in(".concat(formatISODatetimeForAnalytics(startDate), "..").concat(formatISODatetimeForAnalytics(endDate), ")"),
                ],
                metrics: PROFILE_METRICS.map(function (profileMetricProperty) { return profileMetricProperty.apiKey; }),
                page: page,
            };
            return connector
                .getApiClient()
                .fetchAnalyticsProfileMetrics(body)
                .then(function (r) { return r.json(); })
                .then(function (response) {
                table.appendRows(rowsFormatter(response));
                return response;
            })
                .then(function (result) {
                var paging = result.paging;
                var thereAreMorePages = (paging === null || paging === void 0 ? void 0 : paging.current_page) !== (paging === null || paging === void 0 ? void 0 : paging.total_pages);
                processingContext.totalCountProcessed += result.data.length;
                connector.getTableau().reportProgress("Loaded ".concat(processingContext.totalCountProcessed.toLocaleString(), " profile metrics"));
                if (thereAreMorePages) {
                    resolve(getProfileMetrics({
                        customerProfileIds: customerProfileIds,
                        connector: connector,
                        table: table,
                        done: done,
                        bodyParams: { page: page + 1, startDate: startDate, endDate: endDate },
                        rowsFormatter: rowsFormatter,
                        processingContext: processingContext,
                    }));
                }
                else {
                    resolve();
                }
            })
                .catch(reject);
        }, 0);
    });
};
export default ProfileMetrics;
